import PropTypes from 'prop-types';

export const WarningIcon = ({ size = 12, color = '#E7000B' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2781_6443)">
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4V6"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8H6.005"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2781_6443">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

WarningIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const CompletedIcon = ({
  size = 12,
  color = '#16A34A',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5" stroke={color} />
    <path
      d="M3.5 6.2L5.2 7.9L8.5 4.6"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CompletedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const OnHoldIcon = ({
  size = 12,
  color = '#EA580C',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5" stroke={color} />
    <path
      d="M4.5 4.2V7.8"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="1"
    />
    <path
      d="M7.5 4.2V7.8"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="1"
    />
  </svg>
);

OnHoldIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const InProgressIcon = ({
  size = 12,
  color = '#CA8A04',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5" stroke={color} />
    <path
      d="M6 3.2V6L8 7"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    />
  </svg>
);

InProgressIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const CalendarIcon = ({
  size = 16,
  color = '#ff9900',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 1V3"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1V3"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V10C1.5 10.5523 1.94772 11 2.5 11H9.5C10.0523 11 10.5 10.5523 10.5 10V3C10.5 2.44772 10.0523 2 9.5 2Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 5H10.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CalendarIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const LocationPinIcon = ({
  size = 16,
  color = '#ff9900',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 1.5C4.34315 1.5 3 2.84315 3 4.5C3 6.75 6 10.5 6 10.5C6 10.5 9 6.75 9 4.5C9 2.84315 7.65685 1.5 6 1.5Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6C6.82843 6 7.5 5.32843 7.5 4.5C7.5 3.67157 6.82843 3 6 3C5.17157 3 4.5 3.67157 4.5 4.5C4.5 5.32843 5.17157 6 6 6Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

LocationPinIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const PhoneIcon = ({ size = 16, color = '#ff9900', className = '' }) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.416 7.784C6.51926 7.83142 6.6356 7.84226 6.74585 7.81472C6.85609 7.78718 6.95367 7.72291 7.0225 7.6325L7.2 7.4C7.29315 7.2758 7.41393 7.175 7.55279 7.10557C7.69164 7.03614 7.84475 7 8 7H9.5C9.76522 7 10.0196 7.10536 10.2071 7.29289C10.3946 7.48043 10.5 7.73478 10.5 8V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5C7.11305 10.5 4.82387 9.55179 3.13604 7.86396C1.44821 6.17613 0.5 3.88695 0.5 1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H3C3.26522 0.5 3.51957 0.605357 3.70711 0.792893C3.89464 0.98043 4 1.23478 4 1.5V3C4 3.15525 3.96386 3.30836 3.89443 3.44721C3.825 3.58607 3.7242 3.70685 3.6 3.8L3.366 3.9755C3.27421 4.04559 3.20951 4.14529 3.1829 4.25768C3.15628 4.37006 3.16939 4.48819 3.22 4.592C3.90334 5.97993 5.02721 7.1024 6.416 7.784Z"
      stroke="#FF9900"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

PhoneIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const MailIcon = ({ size = 16, color = '#ff9900', className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.5 3.25v5.5C1.5 9.552 1.948 10 2.5 10h7c.552 0 1-.448 1-1.25v-5.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 3.25L6 6.75 10.5 3.25"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 3.25h9"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

MailIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const HomeIcon = ({ size = 20, color = '#ff9900', className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Roof */}
    <path
      d="M2 5.5L6 2L10 5.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Walls */}
    <path
      d="M3 5.5V9.5C3 9.776 3.224 10 3.5 10H8.5C8.776 10 9 9.776 9 9.5V5.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Door */}
    <path
      d="M5 10V7.2C5 7.08954 5.08954 7 5.2 7H6.8C6.91046 7 7 7.08954 7 7.2V10"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

HomeIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const ClientIcon = ({
  size = 16,
  color = '#ff9900',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 6C7.38071 6 8.5 4.88071 8.5 3.5C8.5 2.11929 7.38071 1 6 1C4.61929 1 3.5 2.11929 3.5 3.5C3.5 4.88071 4.61929 6 6 6Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 10C2.5 8.2 4 7 6 7C8 7 9.5 8.2 10 10"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ClientIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const FloorIcon = ({ size = 16, color = '#ff9900', className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Top Floor */}
    <rect
      x="2"
      y="2"
      width="8"
      height="2"
      rx="0.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Middle Floor */}
    <rect
      x="2"
      y="5"
      width="8"
      height="2"
      rx="0.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom Floor */}
    <rect
      x="2"
      y="8"
      width="8"
      height="2"
      rx="0.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

FloorIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const EditIcon = ({ size = 18, color = '#fff' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

EditIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const WhatsAppIcon = ({ size = 32, color = '#fff' }) => (
  <svg
    fill="#ffffff"
    width={size}
    height={size}
    viewBox="-2 -2 24 24"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
  >
    <path d="M9.516.012C4.206.262.017 4.652.033 9.929a9.798 9.798 0 0 0 1.085 4.465L.06 19.495a.387.387 0 0 0 .47.453l5.034-1.184a9.981 9.981 0 0 0 4.284 1.032c5.427.083 9.951-4.195 10.12-9.58C20.15 4.441 15.351-.265 9.516.011zm6.007 15.367a7.784 7.784 0 0 1-5.52 2.27 7.77 7.77 0 0 1-3.474-.808l-.701-.347-3.087.726.65-3.131-.346-.672A7.62 7.62 0 0 1 2.197 9.9c0-2.07.812-4.017 2.286-5.48a7.85 7.85 0 0 1 5.52-2.271c2.086 0 4.046.806 5.52 2.27a7.672 7.672 0 0 1 2.287 5.48c0 2.052-.825 4.03-2.287 5.481z" />
    <path d="M14.842 12.045l-1.931-.55a.723.723 0 0 0-.713.186l-.472.478a.707.707 0 0 1-.765.16c-.913-.367-2.835-2.063-3.326-2.912a.694.694 0 0 1 .056-.774l.412-.53a.71.71 0 0 0 .089-.726L7.38 5.553a.723.723 0 0 0-1.125-.256c-.539.453-1.179 1.14-1.256 1.903-.137 1.343.443 3.036 2.637 5.07 2.535 2.349 4.566 2.66 5.887 2.341.75-.18 1.35-.903 1.727-1.494a.713.713 0 0 0-.408-1.072z" />
  </svg>
);

WhatsAppIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export const HideIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    width="16"
    height="16"
    viewBox="0 0 24 24"
  >
    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
  </svg>
);

export const ShowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M256 36C143.903 36 55.019 144.529 18.291 197.539A102.64 102.64 0 0 0 0 256c0 20.898 6.389 41.284 18.291 58.461C55.019 367.471 143.903 476 256 476s200.981-108.529 237.709-161.539A102.64 102.64 0 0 0 512 256c0-20.898-6.389-41.284-18.291-58.461C456.981 144.529 368.097 36 256 36m0 360c-77.196 0-140-62.804-140-140s62.804-140 140-140 140 62.804 140 140-62.804 140-140 140" />
    <circle cx="256" cy="256" r="80" />
  </svg>
);

export const DeletIcon = ({ color = 'red', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4V4zm2 2h6V4H9v2zM6.074 8l.857 12H17.07l.857-12H6.074zM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1z"
      fill={color}
    />
  </svg>
);

DeletIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const SearchIcon = ({ color = '#BDBDBD' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    style={{ stroke: color }}
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z"
    />
  </svg>
);

SearchIcon.propTypes = {
  color: PropTypes.string,
};

export const LeftArrowIcon = ({ color = '#BDBDBD' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    style={{ stroke: color }}
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

LeftArrowIcon.propTypes = {
  color: PropTypes.string,
};

export const BackButtonIcon = ({ color = '#FFCC00', width = 6, height = 11 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      d="M5 10L1 5.5L5 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BackButtonIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const RightArrowIcon = ({ color = '#BDBDBD' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    style={{ stroke: color }}
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

RightArrowIcon.propTypes = {
  color: PropTypes.string,
};

export const BillIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18,1H6A3,3,0,0,0,3,4V22a1,1,0,0,0,1.8.6L6.829,19.9l1.276,2.552a1,1,0,0,0,.8.549.981.981,0,0,0,.89-.4L12,19.667,14.2,22.6a.983.983,0,0,0,.89.4,1,1,0,0,0,.8-.549L17.171,19.9,19.2,22.6a1,1,0,0,0,.8.4,1,1,0,0,0,1-1V4A3,3,0,0,0,18,1Zm1,18-1.2-1.6a.983.983,0,0,0-.89-.4,1,1,0,0,0-.8.549l-1.276,2.552L12.8,17.4a1,1,0,0,0-1.6,0L9.171,20.105,7.9,17.553A1,1,0,0,0,7.09,17a.987.987,0,0,0-.89.4L5,19V4A1,1,0,0,1,6,3H18a1,1,0,0,1,1,1ZM17,9a1,1,0,0,1-1,1H8A1,1,0,0,1,8,8h8A1,1,0,0,1,17,9Zm-4,4a1,1,0,0,1-1,1H8a1,1,0,0,1,0-2h4A1,1,0,0,1,13,13Z" />
  </svg>
);

BillIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const InspectionIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 21h22V3H1zM2 4h20v16H2zm17 3H5V6h14zM8 9V8h8v1zm12 6h1a3.994 3.994 0 1 1-2.515-3.716l-.369.93A3 3 0 1 0 20 15zm.648-3.306l.704.711-4.354 4.3-1.951-1.951.707-.707 1.248 1.248zM4 15h5v1H4z" />
    <path fill="none" d="M0 0h24v24H0z" />
  </svg>
);

InspectionIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const StockIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#444"
      d="M12 6v-6h-8v6h-4v7h16v-7h-4zM7 12h-6v-5h2v1h2v-1h2v5zM5 6v-5h2v1h2v-1h2v5h-6zM15 12h-6v-5h2v1h2v-1h2v5z"
    ></path>
    <path fill="#444" d="M0 16h3v-1h10v1h3v-2h-16v2z"></path>
  </svg>
);

StockIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const EquipmentIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#444"
      d="M12 6v-6h-8v6h-4v7h16v-7h-4zM7 12h-6v-5h2v1h2v-1h2v5zM5 6v-5h2v1h2v-1h2v5h-6zM15 12h-6v-5h2v1h2v-1h2v5z"
    ></path>
    <path fill="#444" d="M0 16h3v-1h10v1h3v-2h-16v2z"></path>
  </svg>
);

EquipmentIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const CartIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    version="1.1"
    id="Uploaded to svgrepo.com"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <style type="text/css"></style>
    <path
      className="sharpcornerseen"
      d="M10,27h4c0,1.105-0.895,2-2,2S10,28.105,10,27z M23,29c1.105,0,2-0.895,2-2h-4
	C21,28.105,21.895,29,23,29z M30,9H6.819l-1-5H2v2h2.181l4,20H26v-2H9.819l-0.6-3H26L30,9z"
    />
  </svg>
);

CartIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const IssueIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 014-4h8a4 4 0 014 4v8a4 4 0 01-4 4H4a4 4 0 01-4-4V4zm6.996.165a1.017 1.017 0 112.012 0L8 11 6.996 4.165zM8 11a1 1 0 110 2 1 1 0 010-2z"
      fill="#000000"
    />
  </svg>
);

IssueIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const IDIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>profile</title>
    <path d="M28 9h-1.958v-2.938l-4.042-0.062 0.021 3h-12.146l0.083-3-3.958 0.062v3l-2-0.062c-1.104 0-2 0.896-2 2v14c0 1.104 0.896 2 2 2h24c1.104 0 2-0.896 2-2v-14c0-1.104-0.896-2-2-2zM23 7h2v4h-2v-4zM10 13.812c1.208 0 2.188 1.287 2.188 2.875s-0.98 2.875-2.188 2.875-2.188-1.287-2.188-2.875 0.98-2.875 2.188-2.875zM7 7h2v4h-2v-4zM5.667 22.948c0 0 0.237-1.902 0.776-2.261s2.090-0.598 2.090-0.598 1.006 1.075 1.434 1.075c0.427 0 1.433-1.075 1.433-1.075s1.552 0.238 2.091 0.598c0.633 0.422 0.791 2.261 0.791 2.261h-8.615zM26 22h-9v-1h9v1zM26 20h-9v-1h9v1zM26 18h-9v-1h9v1zM26 16h-9v-1h9v1z"></path>
  </svg>
);

IDIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const BulldozerIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 -1 24 24"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
    className="jam jam-tools"
  >
    <path d="M2 8.654l2.813 2.822 6.332-6.35-2.814-2.823-6.332 6.35zm4.441 8.128l2.11-2.117a.993.993 0 0 1 1.408 0 1 1 0 0 1 0 1.411l-2.11 2.117a1 1 0 0 1 0 1.411L6.44 21.015a.993.993 0 0 1-1.407 0l-1.407-1.41a1 1 0 0 1 0-1.412l1.407-1.411a.993.993 0 0 1 1.407 0zm9.146-6.35l6.331-6.35-1.407-1.412-6.331 6.35c-.777-.78-.912-1.907-.302-2.52L19.406.956c.61-.612 1.735-.477 2.512.303l1.407 1.41c.778.78.913 1.909.302 2.52l-5.528 5.545c-.61.612-1.735.477-2.512-.303zm-.924 3.866L9.738 9.36l-.704.706 4.925 4.939.704-.706zm1.407 1.412l-.704.705 1.759 1.764c.194.195.51.195.703 0a.5.5 0 0 0 0-.705L16.07 15.71zM2.06 5.77a1.5 1.5 0 0 1 .291-1.704l1.407-1.41a1.49 1.49 0 0 1 1.699-.293L6.924.892a1.986 1.986 0 0 1 2.814 0l2.814 2.823a2 2 0 0 1 0 2.822l-1.407 1.411 8.09 8.114a2.5 2.5 0 0 1 0 3.528 2.482 2.482 0 0 1-3.517 0l-8.09-8.114-1.408 1.411c-.777.78-2.037.78-2.814 0L.592 10.065a2 2 0 0 1 0-2.823l1.467-1.47z" />
  </svg>
);

BulldozerIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const MaterialOutIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 1024 1024"
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#000000"
      d="M704 288h131.072a32 32 0 0131.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 11-64 0v-96H384v96a32 32 0 01-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 01-31.808-35.2l57.6-576a32 32 0 0131.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 483.84L768 698.496V928a32 32 0 11-64 0V698.496l-73.344 73.344a32 32 0 11-45.248-45.248l128-128a32 32 0 0145.248 0l128 128a32 32 0 11-45.248 45.248z"
    />
  </svg>
);

MaterialOutIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export const ConsumptionIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    fill={color}
    width={size}
    height={size}
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5V4H11V3.5C11 1.567 9.433 0 7.5 0C5.567 0 4 1.567 4 3.5V4H5V3.5Z"
      fill="#000000"
    />
    <path
      d="M1.90432 6.33435C1.98872 5.5747 2.63082 5 3.39514 5H11.6051C12.3694 5 13.0115 5.5747 13.0959 6.33435L13.8737 13.3344C13.9724 14.2229 13.2769 15 12.3828 15H2.61737C1.72335 15 1.02781 14.2229 1.12654 13.3344L1.90432 6.33435Z"
      fill="#000000"
    />
  </svg>
);

ConsumptionIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

// export const EyeIcon = ({ size = 12, color = '#6B7280' }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//       stroke={color}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//       stroke={color}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// EyeIcon.propTypes = {
//   color: PropTypes.string,
//   size: PropTypes.string,
// };

export const TextIcon = ({ className = 'w-4 h-4', size, color = 'currentColor' }) => (
  <svg className={className} width={size} height={size} fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h10M4 18h6" />
  </svg>
);

TextIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export const NumberIcon = ({ className = 'w-4 h-4', size, color = 'currentColor' }) => (
  <svg className={className} width={size} height={size} fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
  </svg>
);

NumberIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export const DateIcon = ({ className = 'w-4 h-4', size, color = 'currentColor' }) => (
  <svg className={className} width={size} height={size} fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

DateIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export const BooleanIcon = ({ className = 'w-4 h-4', size, color = 'currentColor' }) => (
  <svg className={className} width={size} height={size} fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth="2">
    <rect x="1" y="7" width="22" height="10" rx="5" ry="5" />
    <circle cx="16" cy="12" r="3" fill="currentColor" stroke="none" />
  </svg>
);

BooleanIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export const GripHandle = ({ className = 'w-4 h-4 text-gray-400', size, color = 'currentColor' }) => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    className={className}
    fill={color}
  >
    <circle cx="2" cy="2" r="1.5" />
    <circle cx="8" cy="2" r="1.5" />
    <circle cx="2" cy="6" r="1.5" />
    <circle cx="8" cy="6" r="1.5" />
    <circle cx="2" cy="10" r="1.5" />
    <circle cx="8" cy="10" r="1.5" />
    <circle cx="2" cy="14" r="1.5" />
    <circle cx="8" cy="14" r="1.5" />
  </svg>
);

GripHandle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export const LockIcon = ({ className = 'w-4 h-4 text-gray-400', color = 'currentColor' }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17,9V7A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9ZM9,7a3,3,0,0,1,6,0V9H9Zm9,12a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z" />
  </svg>
);

LockIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export const EyeIcon = ({ className = 'w-4 h-4 text-gray-400', color = 'currentColor' }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

EyeIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export function ArrowBackcon({ className = 'w-5 h-5', color = '#FFCC00', strokeWidth = 1.5 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className={className}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
      />
    </svg>
  );
}

ArrowBackcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export const DownloadIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    stroke={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
    />
  </svg>
);

DownloadIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};


export const LoaderIcon = ({ size = 24, color = '#000000' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="evenodd" clipRule="evenodd">
      <path
        d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z"
        opacity=".2"
      />
      <path d="M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z" />
    </g>
  </svg>
);

LoaderIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export const UndoArrowIcon = ({ color = '#000000', width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 206.108 206.108"
    fill={color}
  >
    <path d="M152.774,69.886H30.728l24.97-24.97c3.515-3.515,3.515-9.213,0-12.728c-3.516-3.516-9.213-3.515-12.729,0L2.636,72.523
	c-3.515,3.515-3.515,9.213,0,12.728l40.333,40.333c1.758,1.758,4.061,2.636,6.364,2.636c2.303,0,4.606-0.879,6.364-2.636
	c3.515-3.515,3.515-9.213,0-12.728l-24.97-24.97h122.046c19.483,0,35.334,15.851,35.334,35.334s-15.851,35.334-35.334,35.334H78.531
	c-4.971,0-9,4.029-9,9s4.029,9,9,9h74.242c29.408,0,53.334-23.926,53.334-53.334S182.182,69.886,152.774,69.886z"/>
  </svg>
);

UndoArrowIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};